import React, { Component } from "react";
import { Row, Card, CardTitle, Label, FormGroup, Button } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import axios from "../../containers/api";
import {   showCatchError  } from "../../helpers/Utils";

class ReturnBank extends Component {
  constructor(props) {
    super(props);
     
      
      this.state = {
          message: (this.props.location.search !== undefined && this.props.location.search !== null) ? new URLSearchParams(this.props.location.search).get("msg"): null,
          
          result: [],
          
          errors: [],
          isPay: true,
      };
   
}
SetState = async () => {
  await this.setState({
      isPay: false,
  })
    }
    
Redirectback = () => {

  this.props.showSpinner();

  const addModel = {

      refId: this.state.refId, 
      amount : this.state.amount,

  };
  axios.post('/api/v1/SalePayment/VerifySalePayment')
      .then((res) => {
          // handle success
          if (res.status === 200) {
              this.props.hideSpinner();
              this.setState({
                  result: res.data,
                 
              })

          }

      })
      .catch((error) => {
          // handle error
          this.setState({
              isPay: false,

          });
          this.props.hideSpinner();
          this.props.showAlert(showCatchError(error), "error");
          console.log(error.response);
      });
};
  render() {

    return (
        <Row className="justify-content-center align-items-center d-flex mt-5">
          <Colxx xxs="12" md="5">
            <Card className="auth-card">
              <div className="form-side justify-content-center align-items-center d-flex flex-column">
                <div className="logo-single mb-2"/>
                <CardTitle className="mb-5">
               
                </CardTitle>
                <p className='package-info' > 
                            {this.state.message} </p>
                            <div className="form-row-center">
                             <a href={"bank://shatabar/success"}>
                                <button type="button" className="btn">بازگشت به اپلیکیشن</button>
                            </a>
                       
                            </div>
                            <div className="form-row-center">
                            <a href={"/"}>
                                <button type="button" className="btn">بازگشت به بازارگاه </button>
                            </a>
                            </div>
              </div>           
            </Card>
          </Colxx>

        </Row>
    );
  }
}

export default ReturnBank;